module.exports = __webpack_public_path__ + "static/media/all-the-things-you-are-mcm-trio.1a5e7e30.mp3";